import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Input,
  Modal,
  notification,
  Row,
  Switch,
  Table,
  Tag,
  Typography,
  Space,
  Tabs,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  GlobalTableStyle,
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { ColumnsType } from "antd/es/table";
import CustomCard from "../../countCard/CustomCard";
import DriverCard from "./DriverCard";
import pageSize from "../../../constants/pageSize";
import {
  DeleteButton,
  PrimaryButton,
  VerifyButton,
  ViewDetailsButton,
  RefreshButton,
} from "../../styled/Button.styled";
import {
  useDeleteDriverByIdMutation,
  useGetAllDriverQuery,
  useGetDriverCountQuery,
  useReactivateDriverByIdMutation,
  useUpdateDriverStatusByIdMutation,
} from "../../../feature/Driver/driverApiSlice";
import { IDriver } from "../../../types/driver";
import constants from "../../../constants";

import { fullName } from "../../../utils/fullName";
export default function Driver() {
  const navigate = useNavigate();
  const { confirm } = Modal;
  const { data, isLoading, isFetching, refetch } = useGetAllDriverQuery();
  const { data: countData, refetch: refetchCount } = useGetDriverCountQuery();
  const [nameValue, setNameValue] = useState("");
  const [driverId, setDriverId] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [vehicleNumberValue, setVehicleNumberValue] = useState("");
  const [walletValue, setWalletValue] = useState("");
  const [cabStandValue, setCabStandValue] = useState("");
  const [deleteDriverById] = useDeleteDriverByIdMutation();
  const [reactivateDriverById] = useReactivateDriverByIdMutation();
  const [activeTab, setActiveTab] = useState<"active" | "deleted">("active");
  const [updateDriverStatusById] = useUpdateDriverStatusByIdMutation();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(pageSize);
  const location = useLocation();
  const [driverStatusValue, setDriverStatusValue] = useState("");
  const [isRefreshing, setIsRefreshing] = useState(false);

  const showConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Delete Driver?",
      onOk() {
        onDelete(id);
      },
      onCancel() { },
    });
  };
 useEffect(() => {
    // Restore page from URL when component mounts or when navigating back
    const urlParams = new URLSearchParams(location.search);
    const pageFromUrl = urlParams.get('page');
    if (pageFromUrl) {
      setCurrentPage(parseInt(pageFromUrl, 10));
    }
  }, [location.search]);

  const showReactivateConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Reactivate This Driver?",
      content:
        "The driver will move to the Active tab and must be verified again before going active.",
      onOk() {
        return reactivateDriverById(id)
          .unwrap()
          .then(() => {
            notification.success({
              message: "Driver reactivated. Please verify the driver.",
              placement: "bottomLeft",
            });
            setActiveTab("active");
            setCurrentPage(1);
          })
          .catch((error: any) => {
            notification.error({
              message: "Error",
              description:
                error?.data?.message || error?.message || "Failed to reactivate driver",
              placement: "bottomLeft",
            });
          });
      },
      onCancel() { },
    });
  };

  const onDelete = (id: number) => {
    deleteDriverById(id)
      .unwrap()
      .then(() => {
        notification.success({
          message: "Sucessfully Deleted!",
          placement: "bottomLeft",
        });
      })
      .catch((error: any) => {
        notification.error({
          message: "Error",
          description: error.data.message,
          placement: "bottomLeft",
        });
      });
  };
  const toogleSwitch = (id: any) => {
    updateDriverStatusById(id)
      .unwrap()
      .then((res: any) => {
        if (res.statusCode === 500) {
          notification.error({
            message: "Cannot Update Status",
            description: res.message || "An error occurred while updating driver status",
            placement: "bottomLeft",
          });
        } else {
          notification.success({
            message: "Success",
            description: "Driver status updated successfully",
            placement: "bottomLeft",
          });
        }
      })
      .catch((error: any) => {
        notification.error({
          message: "Error",
          description: error?.data?.message || error?.message || "Failed to update driver status",
          placement: "bottomLeft",
        });
      });
  };

  const deletedLabel = (record: IDriver) =>
    record.deletedBy === "DRIVER"
      ? "Acc. deleted by driver"
      : record.deletedBy === "ADMIN"
      ? "Acc. deleted by admin"
      : "Acc. deleted";

  const columns: ColumnsType<IDriver> = [
    {
      key: "name",
      width: 300,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Name</Typography.Text>
          <div>
            <Input.Search
              onChange={(e) => {
                setNameValue(e.target.value);
              }}
              placeholder="Search here"
            />
          </div>
        </div>
      ),
      filteredValue: [nameValue],
      onFilter: (value: any, record) => {
        return record.firstName
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (_: any, record) => {
        const defaultImageUrl = 'https://himcab.admin.ripple-anubudh.tech/static/media/defaultImage.b0698f102d5ca2413c6ab0dc0f4be3ad.svg';
        return (
          <>
            {record.isVerified === true ? (
              <>
                <Row>
                  <Col span={6}>
                  <div style={{ marginRight: '140px' }}>
                    <img
                      alt="Driver"
                      src={`${record.image}`|| `${defaultImageUrl}`}
                      style={{
                        height: "45px",
                        width: "45px",
                        borderRadius: "30px",

                      }}
                    />
                    </div>
                  </Col>
                  <Col span={18} style={{ marginTop: "0.8rem" }}>
                    {fullName(record.firstName, record.lastName)}
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col span={6}>
                    {" "}
                    <img
                      alt="Place"
                      src={`${record.image}`}
                      style={{
                        height: "45px",
                        width: "45px",
                        borderRadius: "30px",
                      }}
                    />
                  </Col>
                  <Col span={18}>
                    <Row>
                      <Col >
                        {" "}
                        <Tag color="#14A011" style={{ fontSize: "8px" }}>
                          NEW
                        </Tag>
                      </Col>
                      <Col>

                        {fullName(record.firstName, record.lastName)}

                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </>
        );
      },
    },
    {
      key: "id",
      width: 100,

      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>DriverId</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setDriverId(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [driverId],
      onFilter: (value: any, record) => {
        return record.id
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return record.id;
      },
      dataIndex: "id",
    },
    {
      key: "phoneNumber",
      width: 120,

      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Phone</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setPhoneValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [phoneValue],
      onFilter: (value: any, record) => {
        return record.phoneNumber

          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return record?.phoneNumber;
      },
      dataIndex: "phoneNumber",
    },
    {
      key: "vehicle",
      width: 130,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Vehicle</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setVehicle(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [vehicle],
      onFilter: (value: any, record) => {
        return (record?.vehicleDto?.vehicleModel ?? "")
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return record?.vehicleDto?.vehicleModel ?? "-";
      },
    },
    {
      key: "vehicleNumber",
      width: 150,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Vehicle No.</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setVehicleNumberValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [vehicleNumberValue],
      onFilter: (value: any, record) => {
        return String(record?.vehicleDto?.vehicleNumber ?? "-")
          .toLowerCase()
          .includes(String(value).toLowerCase());
      },
      render: (_, record) => record?.vehicleDto?.vehicleNumber ?? "-",
    },
    {
      key: "cabStand",
      width: 240,

      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Driver's Cab Stand</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setCabStandValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [cabStandValue],
      onFilter: (value: any, record) => {
        const cabStand = record?.cabStand || "-";
        return cabStand
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (_, record) => {
        const cabStand = record?.cabStand || "-";
        if (cabStand === "-") return "-";
        
        return (
          <div 
            // style={{ 
            //   maxWidth: '100px',
            //   overflow: 'hidden',
            //   textOverflow: 'ellipsis',
            //   whiteSpace: 'nowrap',
            //   cursor: 'pointer'
            // }}
            title={cabStand}
          >
            {cabStand}
          </div>
        );
      },
      dataIndex: "cabStand",
    },
    {
      key: "walletAmount",
      width: 130,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Wallet Amount</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setWalletValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [walletValue],
      onFilter: (value: any, record) => {
        const amount = parseFloat(record.amount || '0').toFixed(2);
        return amount
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (_, record) => {
        return `₹${parseFloat(record.amount || '0').toFixed(2)}`;
      },
      dataIndex: "amount",
    },
    {
      key: "driverStatus",
      width: 190,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Driver Status</Typography.Text>
          <Input.Search
            placeholder="Search here"
            onChange={(e) => {
              setDriverStatusValue(e.target.value);
            }}
          />
        </div>
      ),
      filteredValue: [driverStatusValue],
      onFilter: (value: any, record) => {
        const status = record.onlineStatus ? "ONLINE" : "OFFLINE";
        return status.toLowerCase().includes(String(value).toLowerCase());
      },
      render: (_, record) =>
        record.isDeleted ? (
          <Typography.Text strong style={{ color: "#d32f2f" }}>
            {deletedLabel(record)}
          </Typography.Text>
        ) : (
          <Tag color={record.onlineStatus ? "green" : "red"}>
            {record.onlineStatus ? "ONLINE" : "OFFLINE"}
          </Tag>
        ),
    },
    {
      key: "status",
      width: 120,
      title: (
        <div style={{ paddingLeft: "4px" }}>
          <Typography.Text>Status</Typography.Text>
        </div>
      ),
      render: (_, record) => {
        if (record.isDeleted) {
          return (
            <Typography.Text strong style={{ color: "#d32f2f" }}>
              {deletedLabel(record)}
            </Typography.Text>
          );
        }
        return (
          <>
            {record.isActive === true ? (
              <>
                <div>
                  Active
                </div>
                <Switch
                  onChange={(e) => toogleSwitch(record.id)}
                  checked={record.isActive}
                  style={{ backgroundColor: "green" }}
                />
              </>
            ) : (
              <>
                <div>
                  Inactive
                </div>
                <Switch
                  onChange={() => toogleSwitch(record.id)}
                  checked={record.isActive}
                  style={{ backgroundColor: "red" }}
                />
              </>
            )}
          </>
        );
      },
    },

    {
      key: "viewDetails",
      width: 160,
      render: (_, record) => {
        return (
          <>
            {record.isVerified === true || record.isDeleted ? (
              <>
                <ViewDetailsButton
                  onClick={() => openDriverDetails(record.id)}
                />
              </>
            ) : (
              <>
                <VerifyButton onClick={() => openDriverDetails(record.id)} />
              </>
            )}
          </>
        );
      },
    },
    {
      key: "deleteButton",
      width: 150,
      render: (_, record) =>
        record.isDeleted ? (
          <Button danger onClick={() => showReactivateConfirm(record.id)}>
            Reactivate
          </Button>
        ) : (
          <DeleteButton onClick={() => showConfirm(record.id)} />
        ),
    },
  ];
  // The Status switch is not needed for deleted drivers, only the Reactivate button
  const visibleColumns =
    activeTab === "deleted" ? columns.filter((c) => c.key !== "status") : columns;

  const openDriverDetails = (id: number) => {
    navigate(`edit/${id}?page=${currentPage}`);
  };

  const allDrivers: IDriver[] = data?.data.content ?? [];
  const activeDrivers = allDrivers.filter((d) => !d.isDeleted);
  const deletedDrivers = allDrivers.filter((d) => d.isDeleted);
  const sum = activeDrivers.length;
  const active = countData?.data.isActive;
  const inActive = countData?.data.inActive;
  const onlineStatus = countData?.data.onlineStatus;

  useEffect(() => {
    refetch(); 
  }, [refetch]);

  return (
    <>
      <Row justify="space-between" className="button-bottom-margin">
        <DriverCard
          sum={sum}
          text="Drivers"
          activeText="Active"
          active={active}
          inActiveText="Inactive"
          inActive={inActive}
          onlineText="Online"
          online={onlineStatus}
        />
        <Space>
          <RefreshButton 
            loading={isRefreshing}
            onClick={async () => {
              setIsRefreshing(true);
              await Promise.all([refetch(), refetchCount()]);
              setIsRefreshing(false);
            }}
          />
          <Link to="add">
            <PrimaryButton> Add Driver </PrimaryButton>
          </Link>
        </Space>
      </Row>
      <LightBlueContainer>
        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key as "active" | "deleted");
            setCurrentPage(1);
          }}
          items={[
            { key: "active", label: `Active (${activeDrivers.length})` },
            { key: "deleted", label: `Deleted (${deletedDrivers.length})` },
          ]}
        />
        <WhiteContainer>
          <GlobalTableStyle>
            <Table<IDriver>
              loading={isLoading || isFetching}
              columns={visibleColumns}
              dataSource={activeTab === "active" ? activeDrivers : deletedDrivers}
              rowKey="id"
              pagination={{
                pageSize: currentPageSize,
                current: currentPage,
                pageSizeOptions: ["8", "10", "20", "50", "100"],
                onChange: (page, size) => {
                  setCurrentPage(page);
                  setCurrentPageSize(size);
                },
              }}
            />
          </GlobalTableStyle>
        </WhiteContainer>
      </LightBlueContainer>
    </>
  );
}
